import { render } from "./EditarReceitasGerais.vue?vue&type=template&id=8fae8366&scoped=true"
import script from "./EditarReceitasGerais.vue?vue&type=script&lang=js"
export * from "./EditarReceitasGerais.vue?vue&type=script&lang=js"

import "./EditarReceitasGerais.vue?vue&type=style&index=0&id=8fae8366&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fae8366"]])

export default __exports__